<template>
  <div click.stop>
    <div class="modal is-active">
      <div class="modal-background" @click="cancel"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          {{ editFlaw.id ? $t('flaw_modal.update') : $t('flaw_modal.new') }} {{ $t('flaw_modal.flaw') }}
          <button   style="position: absolute; right: 0; top: 50%; transform: translateY(-50%);"class="delete" aria-label="close" @click="cancel"></button>
        </header>
        <section class="modal-card-body no-scroll">
        

<section class="accordion">
  <input type="checkbox" name="collapse" id="handle1" checked="checked">
  <h2 class="handle">
    <label for="handle1">{{ $t('flaw_modal.flaw_name') }}</label>
  </h2>
  <div class="content">

        <div class="columns is-mobile">
            <div class="field column">
              <label class="label">{{ $t('flaw_modal.inventory') }}</label>
              <div class="control">
                <input type="text" v-model="mapItemName" class="input" disabled />
              </div>
            </div>
            <div class="field column">
             	<label class="label">{{ $t('flaw_modal.flaw_name') }}</label>
              <div class="control">
                <input
                  type="text"
                  v-model="flaw.name"
                  class="input"
                  :placeholder="$t('flaw_modal.flaw_placeholder')"
                  disabled
                />
              </div>
            </div>
          </div>
     
          
      
          <div class="columns is-mobile">
            <div class="field column">
              <label class="label">{{ $t('flaw_modal.floor') }}</label>
              <div class="control">
                <input
                  type="text"
                  v-model="floorName"
                  class="input"
                  :placeholder="$t('flaw_modal.floor_placeholder')"
                  disabled
                />
              </div>
            </div>
            <div class="field column narrow">
              <label class="label">{{ $t('flaw_modal.position_number') }}</label>
              <div class="control">
                <input
                  type="text"
                  v-model="positionNumber"
                  class="input"
                  :placeholder="$t('flaw_modal.position_number_placeholder')"
                  disabled
                />
              </div>
            </div>
          </div>

          <div class="columns is-mobile">
            <div class="field column">
              <label class="label">{{ $t('flaw_modal.description') }}</label>
              <div class="control">
                <input
                  :disabled="editFlaw.id"
                  type="email"
                  v-model="flaw.description"
                  class="input"
                  :placeholder="$t('flaw_modal.description_placeholder')"
                />
              </div>
            </div>
          </div>
          <div class="columns is-mobile">
            <div class="field column" style="margin-top: 12px">
              <label class="label">{{ $t('flaw_modal.responsible') }}</label>
              <div class="control">
                <input
                  :disabled="editFlaw.id"
                  type="email"
                  v-model="responsible"
                  class="input"
                  :placeholder="$t('flaw_modal.responsible_placeholder')"
                />
              </div>
            </div>
            <div class="field column" style="margin-top: 12px">
              <label class="label">{{ $t('flaw_modal.performer') }}</label>
              <div class="control">
                <input
                  :disabled="editFlaw.id"
                  type="email"
                  v-model="flaw.performer"
                  class="input"
                  :placeholder="$t('flaw_modal.performer_placeholder')"
                />
              </div>
            </div>
          </div>
          <div class="columns is-mobile">
            <div class="field column">
              <label class="label">{{ $t('flaw_modal.measure') }}</label>
              <div class="control">
                <input
                  type="text"
                  v-model="editFlaw.measure"
                  class="input"
                  placeholder="..."
                  :readonly="!isOther"
                />
              </div>
            </div>
            <div class="field column">
              <label class="label">{{ $t('flaw_modal.created') }}</label>
              <div class="control">
                <input type="email" v-model="createdDate" class="input" />
              </div>
            </div>
          </div>
  </div>
</section>
<section class="accordion">
  <input type="checkbox" name="collapse2" id="handle2">
  <h2 class="handle">
    <label for="handle2"> {{ $t('flaw_modal.technical_information') }}</label>
  </h2>
  <div class="content">
     <div class="columns is-mobile">
            <div class="field column">
              <div class="label white">{{ $t('flaw_modal.size') }}</div>
              <div class="control">
                <input
                  class="input"
                  type="text"
                  v-model="localItem.size"
                  disabled
                />
              </div>
            </div>
            <div class="field column">
              <div class="label white">{{ $t('flaw_modal.manufacturer') }}</div>
              <div class="control">
                <input
                  class="input"
                  type="text"
                  v-model="localItem.manufacture"
                 disabled
                />
              </div>
            </div>
          </div>
		      <div class="columns is-mobile">
            <div class="field column">
              <div class="label white">{{ $t('flaw_modal.other') }}</div>
              <div class="control">
                <input
                  class="input"
                  type="text"
                  v-model="localItem.other"
                   disabled
                />
		        	</div>
          </div>

           
          </div>
  </div>
</section>
<section class="accordion" v-if="chunkedFields && chunkedFields.length">
  <input type="checkbox" name="collapse3" id="handle3">
  <h2 class="handle">
    <label for="handle3">{{ $t('flaw_modal.service_information') }}</label>
  </h2>
  <div class="content">
    <div
      v-for="(fieldPair, index) in chunkedFields"
      :key="index"
      class="columns is-mobile"
    >
      <div class="field column" v-for="field in fieldPair" :key="field">
        <label class="label white" v-if="fieldLabels[field]">{{ fieldLabels[field] }}</label>
        <div class="control">
          <input
            class="input"
            :type="field.includes('Year') || field === 'FusibleLinkDegrees' ? 'number' : 'text'"
            v-model="localItem.mapItemExtra[field]"
            :disabled="true"
            placeholder="..."
          />
        </div>
      </div>
    </div>
  </div>
</section>

          <img v-if="imgSrc" class="image-preview" :src="imgSrc" @click="toggleImage" />
        </section>
        <footer class="modal-card-foot">
          <div class="column">
            <button
              class="button is-dark"
              :class="isLoading ? 'is-loading' : ''"
              :disabled="disableSave"
              @click="save"
              v-if="!editFlaw.done"
            >
              <span class="icon is-info"><i class="fas fa-save" /></span
              ><span>{{ $t('flaw_modal.save') }}</span>
            </button>
            <button
              class="button is-dark"
              :class="isLoading ? 'is-loading' : ''"
              :disabled="disableSave"
              @click="fix"
              v-if="!editFlaw.done"
            >
              <span class="icon is-info"><i class="fas fa-check" /></span
              ><span>{{ $t('flaw_modal.fix') }}</span>
            </button>
            <button
              v-if="mapItem && mapFile && showMapButton"
              class="button is-dark"
              :class="isLoading ? 'is-loading' : ''"
              :disabled="disableSave"
              @click="toggleModal"
            >
              <span class="icon is-info"><i class="fas fa-check" /></span
              ><span>{{ $t('flaw_modal.show_on_map') }}</span>
            </button>
          </div>
        </footer>
      </div>
      <div class="image-display" v-if="showImage" @click="toggleImage">
        <img v-if="imgSrc" :src="imgSrc" />
      </div>
    </div>
    <FlawOnMap
      v-if="showMapModal"
      :flaw="mapItem"
      :mapImg="mapFile"
      @cancel="showMapModal = !showMapModal"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import FlawOnMap from "./FlawOnMap.vue";
import fireEquipmentService from "@/mixins/fireEquipmentService.js";

export default {
  components: {
    FlawOnMap,
  },
  props: {
    editFlaw: Object,
    showMapButton: {
      type: Boolean,
      default: false, // visa knappen som standard
    },
  },
  data() {
    return {
      flaw: {
        name: "",
        flaw: "",
        email: "",
        phoneNumber: "",
      },
      isLoading: false,
      responsible: "",
      imgSrc: "",
      showImage: false,
      showMapModal: false,
      mapFile: null,
      localItem: { mapItemExtra: {} },
      fieldLabels: fireEquipmentService.getFieldLabels(),
      fieldMap: fireEquipmentService.getFieldMap(),
    };
  },
  watch: {
    errorMessage: function () {
      this.isLoading = false;
    },
  },
  computed: {
    ...mapGetters("roleStore", ["role"]),
    ...mapState("fileStore", ["file"]),
    ...mapState("mapStore", ["map"]),
    ...mapGetters("mapItemStore", ["mapItem"]),
    ...mapGetters("roundHistoryInfoStore", ["roundHistoryInfo"]),
    ...mapGetters("user", ["getUser"]),
    disableSave() {
      return false;
    },
    createdDate() {
      return this.moment(this.flaw.created).format("YYYY-MM-DD HH:mm");
    },
    doneDate() {
      return this.flaw.date ? this.moment(this.flaw.date).format("YYYY-MM-DD HH:mm") : "";
    },
    mapItemName() {
      return this.editFlaw.mapItemName || "-";
    },
    floorName() {
      if (this.mapItem.id && this.mapItem.map) {
        return `${this.mapItem.map.floor.buildingName} - ${this.mapItem.map.floor.name}`;
      }

      if (this.roundHistoryInfo.id) {
        return `${this.roundHistoryInfo.buildingName} - ${this.roundHistoryInfo.floorName}`;
      }

      return "";
    },
    positionNumber() {
      return this.mapItem.positionNumber || "-";
    },
    visibleFields() {
      console.log("this.localItem.fireProtection:", this.localItem.fireProtection);
      const type = this.localItem.fireProtection?.inventoryType;
      console.log("type:", fireEquipmentService.getVisibleFields(type));
      return fireEquipmentService.getVisibleFields(type);
    },
    chunkedFields() {
      const chunkSize = 2;
      const chunks = [];
      for (let i = 0; i < this.visibleFields.length; i += chunkSize) {
        chunks.push(this.visibleFields.slice(i, i + chunkSize));
      }
      return chunks;
    },
	isOther() {
		const key = this.editFlaw?.flawType?.translationKey || '';
		return key.toLowerCase().endsWith('other');
	}
  },
  methods: {
    ...mapActions("roleStore", ["getRole"]),
    ...mapActions("fileStore", ["getFile"]),
    ...mapActions("mapItemStore", ["getMapItem", "setMapItem"]),
    ...mapActions("roundHistoryInfoStore", [
      "getRoundHistoryInfo",
      "setRoundHistoryInfo",
    ]),
    ...mapActions("mapStore", ["getMap"]),
    save() {
      this.$emit("save", this.editFlaw);
    },
    fix() {
      let date = new Date();
      date.setHours(date.getHours() - date.getTimezoneOffset() / 60);
      this.editFlaw.done = date;
      this.editFlaw.doneBy = this.getUser.email;
      this.save();
    },
    cancel() {
      this.$emit("cancel");
    },
    toggleImage() {
      this.showImage = !this.showImage;
    },
    toggleModal() {
      this.showMapModal = !this.showMapModal;
    },
  },
  async created() {
    if (this.editFlaw.id) {
      Object.assign(this.flaw, this.editFlaw);
    }
    if (this.editFlaw.responsible != null) {
      await this.getRole(this.editFlaw.responsible);
      this.responsible = this.role.name || this.editFlaw.responsible;
    } else {
      this.responsible = "";
    }

    if (this.flaw.mapItemId) {
      await this.getMapItem(this.flaw.mapItemId);
      this.localItem = {
        ...this.mapItem,
        mapItemExtra: this.mapItem.mapItemExtra || {},
      };

      // Trigger fields after data is set
      this.visibleFieldsArray = fireEquipmentService.getVisibleFields(
        this.localItem.fireProtection?.inventoryType
      );

      await this.getMap(this.mapItem.map.id);

      if (this.map.file && this.map.file.id) {
        this.mapFile = await this.getFile(this.map.file.id);
      }
    } else {
      this.setMapItem({});
    }

    if (this.flaw.roundHistoryInfoId) {
      await this.getRoundHistoryInfo(this.flaw.roundHistoryInfoId);

      if (Object.keys(this.mapItem).length === 0) {
        await this.getMap(this.roundHistoryInfo.mapId);

        if (this.map.file && this.map.file.id) {
          this.mapFile = await this.getFile(this.map.file.id);
          this.setMapItem({
            ...this.flaw,
            ...{
              map: {
                floor: {
                  name: this.roundHistoryInfo.floorName,
                  buildingName: this.roundHistoryInfo.buildingName,
                },
                name: this.map.name,
              },
              fireProtection: {
                inventoryType: "misc",
              },
              positionX: this.flaw.flawPositionX,
              positionY: this.flaw.flawPositionY,
            },
          });
          console.log("mapItem efter setMapItem fr�n roundHistoryInfo:", this.mapItem);
        }
      }
    } else {
      this.setRoundHistoryInfo({});
    }

    if (this.editFlaw.fileId) {
      this.getFile(this.editFlaw.fileId).then(() => {
        this.imgSrc = this.file;
      });
    }
  },
};
</script>

<style lang="scss">
.multiselect.panel-select.flaw .multiselect__tags {
  white-space: normal;
}
</style>

<style lang="scss" scoped>
.image-preview {
  margin-top: 1rem;
  max-width: 5rem;
  background: white;
  cursor: pointer;
}

.image-display {
  position: absolute;
  z-index: 10;
  background: rgba(0, 0, 0, 0.486);
  height: 80%;
  width: 80%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    display: block;
    height: 80%;
  }
}
.field.column.narrow {
  max-width: 80px;
}
input.input {
  height: 36px;
}
.modal-card-body.no-scroll {
  padding: 0 10px;
}
/*
 CSS for the main interaction
*/
.accordion > input[type="checkbox"] {
  position: absolute;
  left: -100vw;
}

.accordion .content {
  overflow-y: hidden;
  height: 0;
  transition: height 0.3s ease;
}

.accordion > input[type="checkbox"]:checked ~ .content {
  height: auto;
  overflow: visible;
}

.accordion label {
  display: block;
}

.accordion {
  margin-bottom: 1em;
}



.accordion .handle {
box-shadow: 0 0 0 0.25px #ffffff;
border-radius: 2px;
  margin: 0;
  font-size: 1em;
  line-height: 1em;
  margin-top: 10px;
}

.accordion label {
  color: #ffffff;
  cursor: pointer;
  font-weight: normal;
  padding: 10px;
}

.accordion .handle :hover,
.accordion .handle :focus {
  // background: #858585;
}

.accordion .handle label:before {
  content: "+"; /* plus */
  display: inline-block;
  margin-right: 10px;
  font-size: 1em;
  line-height: 1.5em;
  vertical-align: middle;
}

.accordion > input[type="checkbox"]:checked ~ .handle label:before {
  content: "−"; /* minus */
}


*,
*:before,
*:after {
  box-sizing: border-box;
}

.accordion {
  max-width: 65em;
}

.accordion p:last-child {
  margin-bottom: 0;
}
</style>
